/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RemunerationTarifDto } from './RemunerationTarifDto';
import {
    RemunerationTarifDtoFromJSON,
    RemunerationTarifDtoFromJSONTyped,
    RemunerationTarifDtoToJSON,
    RemunerationTarifDtoToJSONTyped,
} from './RemunerationTarifDto';

/**
 * Détail de tarification d'une garantie.
 * @export
 * @interface GarantieTarifDto
 */
export interface GarantieTarifDto {
    /**
     * 
     * @type {string}
     * @memberof GarantieTarifDto
     */
    garantieId?: string;
    /**
     * 
     * @type {string}
     * @memberof GarantieTarifDto
     */
    designation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieTarifDto
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GarantieTarifDto
     */
    primePure?: number;
    /**
     * 
     * @type {number}
     * @memberof GarantieTarifDto
     */
    majoration?: number;
    /**
     * 
     * @type {number}
     * @memberof GarantieTarifDto
     */
    minoration?: number;
    /**
     * 
     * @type {number}
     * @memberof GarantieTarifDto
     */
    primePureTotal?: number;
    /**
     * 
     * @type {Array<RemunerationTarifDto>}
     * @memberof GarantieTarifDto
     */
    remunerations?: Array<RemunerationTarifDto> | null;
    /**
     * 
     * @type {number}
     * @memberof GarantieTarifDto
     */
    prixHT?: number;
    /**
     * 
     * @type {number}
     * @memberof GarantieTarifDto
     */
    taxe?: number;
    /**
     * 
     * @type {number}
     * @memberof GarantieTarifDto
     */
    prixTTC?: number;
    /**
     * 
     * @type {string}
     * @memberof GarantieTarifDto
     */
    bienImmobilierId?: string | null;
}

/**
 * Check if a given object implements the GarantieTarifDto interface.
 */
export function instanceOfGarantieTarifDto(value: object): value is GarantieTarifDto {
    return true;
}

export function GarantieTarifDtoFromJSON(json: any): GarantieTarifDto {
    return GarantieTarifDtoFromJSONTyped(json, false);
}

export function GarantieTarifDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GarantieTarifDto {
    if (json == null) {
        return json;
    }
    return {
        
        'garantieId': json['garantieId'] == null ? undefined : json['garantieId'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'code': json['code'] == null ? undefined : json['code'],
        'primePure': json['primePure'] == null ? undefined : json['primePure'],
        'majoration': json['majoration'] == null ? undefined : json['majoration'],
        'minoration': json['minoration'] == null ? undefined : json['minoration'],
        'primePureTotal': json['primePureTotal'] == null ? undefined : json['primePureTotal'],
        'remunerations': json['remunerations'] == null ? undefined : ((json['remunerations'] as Array<any>).map(RemunerationTarifDtoFromJSON)),
        'prixHT': json['prixHT'] == null ? undefined : json['prixHT'],
        'taxe': json['taxe'] == null ? undefined : json['taxe'],
        'prixTTC': json['prixTTC'] == null ? undefined : json['prixTTC'],
        'bienImmobilierId': json['bienImmobilierId'] == null ? undefined : json['bienImmobilierId'],
    };
}

export function GarantieTarifDtoToJSON(json: any): GarantieTarifDto {
    return GarantieTarifDtoToJSONTyped(json, false);
}

export function GarantieTarifDtoToJSONTyped(value?: GarantieTarifDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garantieId': value['garantieId'],
        'designation': value['designation'],
        'code': value['code'],
        'primePure': value['primePure'],
        'majoration': value['majoration'],
        'minoration': value['minoration'],
        'primePureTotal': value['primePureTotal'],
        'remunerations': value['remunerations'] == null ? undefined : ((value['remunerations'] as Array<any>).map(RemunerationTarifDtoToJSON)),
        'prixHT': value['prixHT'],
        'taxe': value['taxe'],
        'prixTTC': value['prixTTC'],
        'bienImmobilierId': value['bienImmobilierId'],
    };
}

